var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettlementSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4978_11085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.47008 4.14783H12.5301M4.97008 1.23116V4.06616M9.03008 1.23116V3.80366M12.8334 5.25033V8.75033C12.8334 8.87866 12.8334 9.00699 12.8217 9.12949C12.5768 8.82757 12.2673 8.58439 11.916 8.41783C11.5647 8.25127 11.1805 8.16555 10.7917 8.16699C10.1734 8.16699 9.60175 8.38283 9.15258 8.74449C8.84368 8.98862 8.59439 9.29984 8.42359 9.65458C8.25279 10.0093 8.16496 10.3983 8.16675 10.792C8.16675 11.6145 8.54008 12.3437 9.12925 12.822C9.00675 12.8337 8.87842 12.8337 8.75008 12.8337H5.25008C2.33341 12.8337 1.16675 11.667 1.16675 8.75033V5.25033C1.16675 2.33366 2.33341 1.16699 5.25008 1.16699H8.75008C11.6667 1.16699 12.8334 2.33366 12.8334 5.25033Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4168 10.792C13.4168 11.5795 13.0668 12.2795 12.5243 12.7637C12.0576 13.1662 11.4568 13.417 10.7918 13.417C10.1618 13.417 9.57843 13.1953 9.12927 12.822C8.82735 12.577 8.58417 12.2675 8.4176 11.9162C8.25104 11.5649 8.16533 11.1808 8.16677 10.792C8.16677 9.96366 8.54593 9.22283 9.1526 8.74449C9.61687 8.37021 10.1954 8.16639 10.7918 8.16699C11.6143 8.16699 12.3434 8.54033 12.8218 9.12949C13.1951 9.57866 13.4168 10.162 13.4168 10.792Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9551 9.96875V10.9546L10.1384 11.4446",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4978_11085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlementSchedule);
export default __webpack_public_path__ + "static/media/settlement-schedule.893f0a6086041b0952d057f90dc719ef.svg";
export { ForwardRef as ReactComponent };